module.exports = __webpack_public_path__ + "img/guandai_zc_wenruichen.89a00956.jpg";